function FormFooter({ registering, onSwitchMode }) {
  return (
    <>
      {!registering ? (
        <div>
          <p className="signup">Don't have an account?</p>
          <p className="signup">
            <button type="button" onClick={onSwitchMode}>
              Sign up
            </button>
          </p>
        </div>
      ) : (
        <div>
          <p className="signup">
            <button type="button" onClick={onSwitchMode}>
              Back To Login
            </button>
          </p>
        </div>
      )}
    </>
  );
}

export default FormFooter;
